/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__xiangkanBtn */
function tpl__xiangkanBtn(data) {
    var __out = '<div class="mi-detail__read-more-xiangkan"><span class="mi-detail__read-more-xiangkan-icon';
    if (data.isHotWord) {
        __out += " mi-detail__read-more_hot-word";
    }
    __out += '"></span><p class="mi-detail__read-more-xiangkan-btn';
    if (data.isHotWord) {
        __out += " mi-detail__read-more_hot-word";
    }
    __out += '">';
    if (data.buttonText) {
        __out += data.buttonText;
    } else {
        __out += "打开想看APP阅读全文";
    }
    __out += "</p></div>";
    return __out;
}

exports.tpl__xiangkanBtn = tpl__xiangkanBtn;
